import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import './index.css'
import bannerHandler from './utils'
import useWindowSize from '../../hooks/useWindowSize'
import Loading from '../VoidPLP/components/Loading'
import Container from '../grid/Container'
import ClientAPI from '../../common/ClientAPI'
import { sendClickPromoDataToAnalytics, sendImageViewDataListToAnalytics } from '../../common/GoogleTagManager'
import { redirectOpen } from '../../Helpers'
import { addTenantOnLink, removeTenantOnLink } from '../../Helpers/linkHelper'

const api = new ClientAPI()

const onClickHandle = (data) => {
  const { target, tag, url, index } = data.extraProps

  sendClickPromoDataToAnalytics(tag, 'posición', index + 1)
  if (data.isAdvisor) {
    if (data.redirectUrl) {
      data.redirectUrl = removeTenantOnLink(data.redirectUrl)
    }
    api
      .sendAdvisorEvent({
        type: data.type,
        eventUrl: data.extraProps.advisor.clickUrl,
        adUrl: data.adUrl,
        slotId: data.slotId,
        endTime: data.endTime,
      })
      .finally(() => redirectOpen(data.redirectUrl, target))
  } else {
    redirectOpen(url, target)
  }
}

const onViewHandle = (data) => {
  api.sendAdvisorEvent({
    type: data.type,
    eventUrl: data.extraProps.advisor.viewUrl,
    adUrl: data.adUrl,
    slotId: data.slotId,
    startTime: data.startTime,
    endTime: data.endTime,
  })
}

const onVisibleHandle = (promoView) => {
  sendImageViewDataListToAnalytics([promoView], 'category-sliders', 'PLP')
}

const onImpressionHandle = (data) =>
  api.sendAdvisorEvent({
    type: data.type,
    eventUrl: data.extraProps.advisor.impUrl,
    adUrl: data.adUrl,
    slotId: data.slotId,
  })

const BannersCarousel = ({ banners }) => {
  const [sentDataToAnalytics, setSendDataToAnalytics] = useState(false)
  const { isMobile } = useWindowSize()
  let cleanBanners = []
  if (Array.isArray(banners)) {
    cleanBanners = banners.filter((e) => (isMobile ? e.mobile : !e.mobile))
    cleanBanners.forEach((banner) => {
      if (banner.advisor) {
        banner.advisor.redirectUrl = addTenantOnLink(banner.advisor.redirectUrl)
      }
    })
  }

  useEffect(() => {
    if (cleanBanners.length > 0 && !sentDataToAnalytics) {
      sendImageViewDataListToAnalytics(cleanBanners, 'category-sliders', 'PLP')
      setSendDataToAnalytics(true)
    }
  }, [cleanBanners])

  if (cleanBanners.length > 0) {
    return (
      <Container fullWidthMobile>
        <div className="bs__banner-carousel">
          <Slider
            autoplay
            autoplaySpeed={4000}
            infinite
            dots
            pauseOnHover
            speed={500}
            adaptiveHeight
            slidesToShow={1}
            slidesToScroll={1}
            arrows={!isMobile}
            lazyLoad
          >
            {cleanBanners.map((banner, i) =>
              bannerHandler(isMobile, banner, i, onClickHandle, onImpressionHandle, onViewHandle, onVisibleHandle)
            )}
          </Slider>
        </div>
      </Container>
    )
  }
  return <Loading onlyCarousel />
}

BannersCarousel.defaultProps = {
  banners: [],
}

BannersCarousel.propTypes = {
  banners: PropTypes.array,
}

export default BannersCarousel
